export default [
  {
    path: "feedback",
    name: "BizhubFeedback",
    component: () => import("@/views/Bizhub/FeedbackListView.vue"),
    meta: { requiresAuth: true, requiresBizhub: true, menu: { group: "フィードバック", title: "一覧", order: 10 } },
  },
];
